export const GERMANY_TIME_ZONE = '+0200';
export const _MS_PER_DAY = 1000 * 60 * 60 * 24;
